import * as React from 'react';
import type { SVGProps } from 'react';

const IconDeepResearchDoubleSparkle = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 18 18" {...props}>
      <path
        d="M6.589 17.924c.26 0 .455-.216.455-.454a5.584 5.584 0 0 1 5.584-5.583c.26 0 .455-.216.455-.454a.472.472 0 0 0-.455-.454c-3.073 0-5.584-2.51-5.584-5.583a.457.457 0 0 0-.455-.454.471.471 0 0 0-.454.454A5.584 5.584 0 0 1 .551 10.98a.457.457 0 0 0-.455.454c0 .238.217.454.455.454a5.583 5.583 0 0 1 5.584 5.583c0 .26.216.454.454.454ZM13.083 9.061a.29.29 0 0 0 .288-.288 3.544 3.544 0 0 1 3.544-3.543.29.29 0 0 0 .29-.288.3.3 0 0 0-.29-.288 3.553 3.553 0 0 1-3.544-3.543.29.29 0 0 0-.288-.288.299.299 0 0 0-.288.288 3.544 3.544 0 0 1-3.544 3.543.29.29 0 0 0-.289.288.3.3 0 0 0 .29.288 3.544 3.544 0 0 1 3.543 3.543.29.29 0 0 0 .288.288Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default IconDeepResearchDoubleSparkle;
